export default {
  title: 'Template statistics',
  searchPlaceholder: 'Quick search by template name or ID',
  total: 'Templates',
  filters: {
    channel: 'Channel',
    category: 'Template category',
    status: 'Template status',
  },
  th: {
    id: 'Template ID',
    name: 'Template name',
    status: 'Status',
    channel: 'Channel',
    category: 'Category',
    read: 'Read template messages',
  },
  info: {
    status: 'Status:',
    channel: 'Channel:',
    registerDate: 'Template registered:',
    operators: 'Template status for operators:',
    category: 'Template category:',
    toTemplate: 'To template card',
  },
  results: 'Template results',
  resultsHint:
    'In some cases, the statistics may differ from the information in the final report due to minor variations in the way the data is processed.\n\n' +
    'Statistics are updated within an hour after sending messages.',
  period: 'Select period',
  periodHint:
    'If there are statistics available for the same period in the past, the final row of the table will show the changes',
  twoWeeks: 'For 2 weeks',
  interactions: 'Recipient interaction statistics',
  statistics: {
    interacted: 'Total interactions',
    interactedHint:
      'The number of recipient interactions with messages sent using the template.\n\n' +
      'The dynamics show how the percentage of messages has changed over the selected period compared to the previous period of the same duration.',
    sent: 'Sent messages',
    sentHint:
      'The number of messages sent according to the template.\n\n' +
      'The dynamics show how the percentage of messages has changed over the selected period compared to the previous period of the same duration.',
    read: 'Read messages',
    readHint:
      'The number of messages read by recipients according to the template.\n\n' +
      'The dynamics show how the percentage of messages has changed over the selected period compared to the previous period of the same duration.',
    delivered: 'Delivered messages ',
    deliveredHint:
      'The number of messages delivered according to the template.\n\n' +
      "Delivery of messages may be unsuccessful in certain situations, for instance, if the recipient's device is out of service.\n\n" +
      'The dynamics show how the percentage of messages has changed over the selected period compared to the previous period of the same duration.',
    shortLinkClicked: 'Link button clicks',
    shortLinkClickedHint:
      'Only clicks on link buttons for which the "Track clicks on link buttons" setting is enabled when the template is created are counted.\n\n' +
      "Each recipient's click on a link button is taken into account.\n\n" +
      'Traffic statistics are collected within 30 days of a message being sent.',
    chatButtonClicked: 'Chat button clicks',
    chatButtonClickedHint:
      "The recipient's unique click on each chat button is taken into account.",
    replied: 'Quoted messages',
    repliedHint: 'Each case of quoting a message by the recipient is taken into account.',
  },
  chart: {
    sent: 'Sent messages',
    read: 'Read messages',
    delivered: 'Delivered messages',
    interacted: 'Interactions',
  },
  chartNoData: {
    title: 'No data available',
    subtitle: "We don't yet have any statistics on this template for the selected period",
  },
  noData: {
    title: 'Nothing here yet',
    subtitle:
      "Unfortunately, you don't yet have any registered operator templates for which statistics would be available",
    action: 'To templates',
  },
};
